<template>
    <div>
      <ul class="nav nav-tabs justify-content-center" style="clear: right;">

          
          <li class="nav-item">
            <a :class="MaterialsClass">
              <router-link :to="{path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/materials/'}" tag="li">
              Learn
              </router-link>
            </a>
          </li> 
          <li class="nav-item">
            <a :class="AssignmentClass">
              <router-link :to="{path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/assignment/'}" tag="li">
              Practice
              </router-link>
            </a>
          </li>
          <li class="nav-item">
            <div v-if="ReviewClass === 'nav-link disabled'">
              <a :class="ReviewClass" tag="li">
                Peers
              </a>
            </div>
            <div v-else>
              <a :class="ReviewClass">
                <router-link :to="{path: '/course/' + chapterdata.lCId + '/chapter/' + chapterdata.id + '/allReviews/'}" tag="li">
                Peers
                </router-link>
              </a>
            </div>
          </li>
      </ul>
    </div>
</template>

<script>
 export default {
    data() {
      return {
        MaterialsClass: '',
        AssignmentClass: '',
        ReviewClass: ''

      }
    },
    props:['UserSubmissionData','chapterdata'],
    methods: {

      getRoute(route) {
        // console.log("routeName");
        // console.log(route.name);
        if (route.name === "MaterialsLink"){
          this.MaterialsClass = 'nav-link active';
        } else {
          this.MaterialsClass = 'nav-link';
        };
        if (route.name === "AssignmentLink"){
          this.AssignmentClass = 'nav-link active';
        } else {
          this.AssignmentClass = 'nav-link';
        };
        if (route.name === "AllReviewLink"){
          this.ReviewClass = 'nav-link active';
        } else {
          var CurrentUsersSubmissionsInChapter = this.UserSubmissionData.filter( CurrentUsersSubmissionsInChapter => {
              return  (
                  CurrentUsersSubmissionsInChapter.lCId == parseInt(this.chapterdata.lCId) &&  
                  CurrentUsersSubmissionsInChapter.chapterId == parseInt(this.chapterdata.id)
              );
          });
          if (CurrentUsersSubmissionsInChapter[0]) {
            this.ReviewClass = 'nav-link';
          } else {
            this.ReviewClass = 'nav-link disabled'
          }
        }
      }
    },
    watch:{
      '$route' (to){
        this.getRoute(to);
      }
    },
    created() {
      this.getRoute(this.$route);
    }
} 
  
</script>

<style scoped>
.nav-link.active a{
    color: #495057;
}

.nav-tabs .nav-link.disabled {
    color: rgba(0,0,0,.2);
    background-color: transparent;
    border-color: transparent;
}

</style>




// WEBPACK FOOTER //
// src/components/course/chapter/ChapterNavigation.vue